import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Award } from 'lucide-react';

const sections = [
  'Technical Knowledge',
  'Analytical Thinking',
  'Communication Skills',
  'Team & Leadership',
  'Professional Ethics'
];

export default function SkillCard() {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={() => navigate('/assessment/skill/verify')}
      className="skill-card group relative w-full text-left overflow-hidden rounded-3xl p-6 md:p-7 transition-all duration-300"
    >
      <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-emerald-500/10 to-teal-600/10 pointer-events-none" />

      <div className="relative z-10 flex items-start justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="h-12 w-12 rounded-xl bg-gradient-to-br from-emerald-500 to-teal-600 text-white flex items-center justify-center shadow-lg shadow-emerald-500/30">
            <Award className="h-5 w-5" />
          </div>
          <div>
            <h3 className="text-xl font-semibold text-slate-900 font-jakarta">ProEdge Skill Assessment</h3>
            <p className="text-sm text-slate-600">5 Sections · 50 Questions · ~50 min</p>
          </div>
        </div>

        <span className="px-3 py-1 rounded-full text-xs font-semibold bg-emerald-100/85 text-emerald-800 border border-emerald-200">
          Professional
        </span>
      </div>

      <p className="relative z-10 mt-4 text-sm leading-6 text-slate-700">
        Comprehensive professional skills evaluation across technical knowledge, analytical thinking, business communication,
        leadership dynamics, and workplace ethics for professional and entry-level career readiness.
      </p>

      <div className="relative z-10 mt-5 flex flex-wrap gap-2">
        {sections.map((section) => (
          <span
            key={section}
            className="text-[11px] md:text-xs px-3 py-1 rounded-full border border-emerald-200/80 bg-white/75 text-slate-700 backdrop-blur-sm"
          >
            {section}
          </span>
        ))}
      </div>

      <div className="relative z-10 mt-5">
        <div className="skl-cta-shimmer w-full rounded-xl bg-gradient-to-r from-emerald-500 to-teal-600 text-white font-semibold px-4 py-3 flex items-center justify-center gap-2">
          Start Assessment
          <ArrowRight className="h-4 w-4" />
        </div>
      </div>
    </button>
  );
}
